import { requireEnv } from '@/lib/env'
/**
 * Nhost Storage image optimization via query parameters.
 * @see https://docs.nhost.io/products/storage#image-transformation
 */

interface ImageOptimizeOptions {
  /** Target width in pixels */
  w?: number
  /** Target height in pixels */
  h?: number
  /** Output format */
  f?: 'webp' | 'avif'
  /** Quality 1-100 */
  q?: number
}

const STORAGE_HOST = new URL(requireEnv(process.env.NEXT_PUBLIC_NHOST_STORAGE_URL, 'NEXT_PUBLIC_NHOST_STORAGE_URL')).host

/**
 * Add Nhost image transformation params to a storage URL.
 * Returns the URL unchanged if it's not a Nhost storage URL.
 */
export function optimizeStorageImage(
  url: string,
  opts: ImageOptimizeOptions
): string {
  if (!url || !url.includes(STORAGE_HOST)) return url

  const params = new URLSearchParams()
  if (opts.w) params.set('w', String(opts.w))
  if (opts.h) params.set('h', String(opts.h))
  if (opts.f) params.set('f', opts.f)
  if (opts.q) params.set('q', String(opts.q))

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${params.toString()}`
}
